
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Author01 from "../assets/author-01.png";
import { useTranslation } from 'react-i18next';

const CustomerReview = () => {
  const { t, i18n } = useTranslation();
  return (
    <div className="customer-review-sec mb-md-5 mb-4 mt-md-5 mt-4">
      <div className="container">
        <div className="row">
          <div className="col-md-12 mb-4 text-center">
            <h2 className="m-0 p-0">{t("Customer Reviews")}</h2>
          </div>
          <div className="col-md-12">
            {/* Replacing Owl with Swiper */}
            <Swiper
              key={i18n.language}
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              loop={true}
              autoplay={{ delay: 3000 }}
              pagination={{ clickable: true }}
              navigation = {false}
              className="slider-review-sec"
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
            >
              {/* Slide 1 */}
              <SwiperSlide className="item">
                <div className="review-box text-center">
                  <div className="img-box position-relative">
                    <span className="icons-top">
                        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="46" height="46" rx="23" fill="#F49B31"/><g clip-path="url(#clip0_0_1655)"><path d="M28.3165 17.3389C27.1013 18.3185 25.9367 19.9348 24.7722 22.1389C23.6582 24.3429 23 26.7429 22.8481 29.3389H27.4557C27.4051 25.3715 28.6203 21.747 31 18.4164L28.3165 17.3389ZM20.519 17.3389C19.2532 18.3185 18.0886 19.9348 16.924 22.1389C15.8101 24.3429 15.1519 26.7429 15 29.3389H19.6076C19.557 25.3715 20.7722 21.6981 23.2025 18.4164L20.519 17.3389Z" fill="white"/></g><defs><clipPath id="clip0_0_1655"><rect width="16" height="13" fill="white" transform="translate(15 16.5)"/></clipPath></defs></svg>
                    </span>
                    <span className="author-img">
                      <img src={Author01} alt="Author" />
                    </span>
                  </div>
                  <div className="text-box">
                    <div className="banner-text-box">
                      <span className="h-heading">{t("Excellent Service")}</span>
                      <p>
                        {t("text comment")}
                      </p>
                      <h5 className="mt-3">{t("author name")}</h5>
                      <h6>{t("Traveler")}</h6>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              {/* Slide 2 */}
              <SwiperSlide className="item">
                <div className="review-box text-center">
                  <div className="img-box position-relative">
                    <span className="icons-top">
                      <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="46" height="46" rx="23" fill="#F49B31"/><g clip-path="url(#clip0_0_1655)"><path d="M28.3165 17.3389C27.1013 18.3185 25.9367 19.9348 24.7722 22.1389C23.6582 24.3429 23 26.7429 22.8481 29.3389H27.4557C27.4051 25.3715 28.6203 21.747 31 18.4164L28.3165 17.3389ZM20.519 17.3389C19.2532 18.3185 18.0886 19.9348 16.924 22.1389C15.8101 24.3429 15.1519 26.7429 15 29.3389H19.6076C19.557 25.3715 20.7722 21.6981 23.2025 18.4164L20.519 17.3389Z" fill="white"/></g><defs><clipPath id="clip0_0_1655"><rect width="16" height="13" fill="white" transform="translate(15 16.5)"/></clipPath></defs></svg>
                    </span>
                    <span className="author-img">
                      <img src={Author01} alt="Author" />
                    </span>
                  </div>
                  <div className="text-box">
                    <div className="banner-text-box">
                    <span className="h-heading">{t("Excellent Service")}</span>
                      <p>
                        {t("text comment")}
                      </p>
                      <h5 className="mt-3">{t("author name")}</h5>
                      <h6>{t("Traveler")}</h6>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerReview;
